<form [formGroup]="recurrenceForm">
<div class="grid grid-cols-6 gap-4 px-6 py-3">
    <div class="col-span-3 mt-2 break-words flex items-center text-base font-medium primary-font text-gray-500">
        {{"route.repeat" | translate}}
    </div>
    <div class="col-span-3 mt-2 break-words">
        <mat-form-field
            class="w-full items-center text-base font-medium primary-font text-center text-gray-500 dispatchPicker">
            <mat-select #selectRef formControlName="recurrence" >
                <mat-option [value]="''"> {{"text.none" | translate}}
                </mat-option>
                <mat-option [value]="'DAILY'"> {{"text.every_day" | translate}} </mat-option>
                <mat-option [value]="'WEEKLY'"> {{"text.every_week" | translate}} <span
                        class="text-gray-400">on {{
                        getDay(recurrenceForm?.controls?.date_time?.value)}} </span>
                </mat-option>
                <mat-option [value]="'MONTHLY'"> {{"text.every_month" | translate}} <span
                        class="text-gray-400">on the {{
                        getDate(recurrenceForm?.controls?.date_time?.value)}} </span>
                </mat-option>
                <mat-option [value]="'MONTHLY-ORDINAL-WEEK'"> {{"text.every_month" | translate}}
                    <span class="text-gray-400">on the {{
                        getDayWithWeekCount(recurrenceForm?.controls?.date_time?.value)}}
                    </span> </mat-option>
                <mat-option [value]="'YEARLY'"> {{"text.every_year" | translate}} <span
                        class="text-gray-400">on {{
                        getMonthDay(recurrenceForm?.controls?.date_time?.value)}} </span>
                </mat-option>
                <mat-option [value]="'CUSTOM'" *ngIf="options?.custom"> {{"text.custom" | translate}} </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="grid grid-cols-6 border-t border-gray-200 repeat-ends px-6 py-2"
    *ngIf="recurrenceForm?.controls?.recurrence?.value !== ''">
    <ng-container *ngIf="recurrenceForm?.controls?.recurrence?.value === 'CUSTOM'">
        <div class="col-span-3 break-words flex items-center text-base font-medium primary-font text-gray-500 py-5">
            {{"route.repeat" | translate}} <span class="mandatory-field">*</span>
        </div>
        <div class="col-span-3 break-words py-5 pl-2" formGroupName="repeat">
            <div class="flex items-center">
                <div class="flex w-full">
                    <span class="pr-3 flex items-center">
                        {{"text.every" | translate}}
                    </span>
                    <input type="text"
                        formControlName="count"
                        class="disable-field block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white p-2.5 leading-none text-base mr-2">              
                    </div>
                <div class="flex w-full">
                    <mat-form-field
                        class="w-full items-center text-base font-medium primary-font text-center text-gray-500 dispatchPicker">
                        <mat-select formControlName="type">
                            <mat-option [value]="'WEEKS'"> {{"calendar.home.tab.week" |
                                translate}}
                            </mat-option>
                            <mat-option [value]="'MONTHS'"> {{"calendar.home.tab.month" |
                                translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <p class="text-red-500 text-base mt-1" *ngIf="recurrenceFormErrorMessages['count']">{{recurrenceFormErrorMessages['count'] | translate}}</p>
            <div class="flex items-center mt-4">
                <div class="flex w-full items-baseline">
                    <span class="pr-3 flex items-center">
                        {{"text.on" | translate}}
                    </span>

                    <div class="flex items-center w-full flex-col" *ngIf="days.length > 0">
                        <div class="flex items-center justify-between w-full mt-2 relative"
                            *ngFor="let day of days; let week_index = index;">
                            <span class="flex items-center absolute inset-y-0 -left-9"
                                *ngIf="week_index === 4">
                                {{"text.last" | translate}}
                            </span>
                            <div *ngFor="let item of day.week ; let day_index = index;"
                                (click)="setRecurrenceRepeatDay(item,week_index)"
                                class="disable-field flex items-center justify-center p-1 rounded-full mr-1  border border-gray-300 h-8 w-8 text-md  cursor-pointer text-xs"
                                [ngClass]="item.value ? 'bg-blue-500 text-white' : 'bg-white text-black'">
                                {{ item.label.substring(0, 2) }}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="col-span-3 break-words flex items-center text-base font-medium primary-font text-gray-500 pb-5 pt-3">
        {{"route.ends" | translate}} <span class="mandatory-field">*</span>
    </div>
    <div class="col-span-3 break-words pb-5 pl-2 pt-3">
        <div class="flex flex-col items-start" formGroupName="recurrence_ends">
            <div class="flex w-full">
                <input type="radio" value="recurrence_ends_on" class="mr-2 cursor-pointer disable-field" formControlName="type"
                    name="type" id="recurrence_ends_on">
                <label for="recurrence_ends_on" class="pr-7 flex items-center cursor-pointer"
                >
                    {{"text.on" | translate}}
                </label>
                <div class="relative w-full">
                    <span class="absolute inset-y-0 left-0 pl-3 flex items-center"
                    [ngClass]="{'disable' : recurrenceForm.controls.recurrence_ends?.controls?.type?.value === 'recurrence_ends_after'}"
                    >
                        <i class="ti ti-calendar text-black"></i>
                    </span>
                    <input readonly [matDatepicker]="scheduleDatepicker"
                        [datePickerFormat]="utilityService?.dateFormat" [min]="minEndDate"
                        formControlName="ends_on"
                        [ngClass]="[!recurrenceForm.controls.recurrence_ends?.controls?.ends_on?.valid ? 'border-red-600': 'focus:border-indigo-500', recurrenceForm.controls.recurrence_ends?.controls?.type?.value === 'recurrence_ends_after' ? 'disable': '']"
                        class="block disable-field w-full pl-10 rounded-md border cursor-pointer border-gray-300 bg-white p-2.5 leading-none text-base"
                        (click)="setRecurrenceEnd('recurrence_ends_on');scheduleDatepicker.open()">
                </div>
                <mat-datepicker #scheduleDatepicker></mat-datepicker>
            </div>
            <div class="flex mt-3">
                <input type="radio" class="mr-2 cursor-pointer disable-field" formControlName="type"
                    value="recurrence_ends_after" name="type" id="recurrence_ends_after">
                <label for="recurrence_ends_after" class="pr-3 cursor-pointer flex items-center"
                >
                    {{"text.after" | translate}}
                </label>
                <div class="relative">
                    <input type="text" name="repeat_after" id="repeat_after" value="1"
                        (click)="setRecurrenceEnd('recurrence_ends_after')"
                        autocomplete="off" formControlName="ends_after"
                        (blur)="checkEndsAfterValue()"
                        class="block w-28 disable-field rounded-md border border-gray-300 focus:border-indigo-500 bg-white p-2.5 pr-12 leading-none text-base"
                        [ngClass]="{'disable' : recurrenceForm.controls.recurrence_ends?.controls?.type?.value === 'recurrence_ends_on'}"
                        >
                    <span (click)="setRecurrenceEnd('recurrence_ends_after')" class="text-gray-500 absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                    [ngClass]="{'disable' : recurrenceForm.controls.recurrence_ends?.controls?.type?.value === 'recurrence_ends_on'}"
                    >
                        times
                    </span>
                </div>
            </div>
        </div>
        <p class="text-red-500 text-base mt-1" *ngIf="recurrenceFormErrorMessages['ends_after']">{{recurrenceFormErrorMessages['ends_after'] | translate}}</p>
    </div>
    <div *ngIf="!recurrenceFormErrorMessages['ends_after'] && !recurrenceFormErrorMessages['count']"
    class="col-span-6 break-words flex items-top text-base font-medium primary-font text-gray-500 pb-5">
        <div>
            This {{options?.module}} will take place on<b>
                {{rruleText ?? ''}}
            </b>
            <ng-container>
                {{'text.with_total' | translate}}  {{totalInstance}} {{options?.module}} instance(s)
            </ng-container>
        </div>
    </div>
</div>
</form>
